<template>
  <div
    v-if="!isTaiwan"
   :data-tips="t('headerTools.security')" class="header-comps-security" :class="[hoverShowSecurityTips?'hover-show-security-tips':'']">
    <ui-badge v-model="getLoginRiskCount" dot>
      <icon type="security" />
      <ui-alert
        :class="['security-tips',showSecurityTips?'show-security-tips':'']"
        :closable="false"
        :title="t('security.riskEventsTips')"
        type="warning">
      </ui-alert>
    </ui-badge>
  </div>
</template>

<script>
import icon from '../icon'
import i18nHandle from '../../locales'
import storage from '../../utils/storage'
import { Badge, Alert } from 'amumu-ui'

const USER_LOGIN_TIME = 'USER_LOGIN_TIME'

export default {
  components: {
    Icon: icon,
    'ui-badge': Badge,
    'ui-alert': Alert,
  },
  props: {
    loginData: {
      type: Object,
      default: () => ({}),
    },
    riskEventInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      showSecurityTips: false,
      timer: null,
    }
  },
  created() {
    this.loginShowSecurityTips()
  },
  computed: {
    getLoginTime() {
      return this.loginData.loginTime
    },
    getLoginRiskCount() {
      return this.riskEventInfo.loginRiskCount || 0
    },
    isTaiwan() {
      return window.location.host.includes('okki.com')
    },
    /**
     * 本次登录是否异常
     */
    isRiskForCurLogin() {
      return (
        this.loginData.customData && this.loginData.customData.risk !== undefined &&
        this.loginData.customData.risk === 1
      )
    },

    hoverShowSecurityTips() {
      if (this.isRiskForCurLogin || this.getLoginRiskCount <= 0) {
        return false
      }
      return true
    },
  },
  methods: {
    t: i18nHandle.t,
    /**
     * 正常登录且有高危事件未处理时 展示文案提示
     */
    loginShowSecurityTips() {
      if (this.isRiskForCurLogin || this.getLoginRiskCount <= 0) {
        return
      }
      clearTimeout(this.timer)
      if (
        storage.get(USER_LOGIN_TIME) &&
        this.getLoginTime === storage.get(USER_LOGIN_TIME)
      ) {
        return
      }
      this.showSecurityTips = true
      storage.put(USER_LOGIN_TIME, this.getLoginTime)
      this.timer = setTimeout(() => {
        this.showSecurityTips = false
      }, 10000)
    },
  },
}
</script>

<style lang="scss">
.header-comps-security {
  position: relative;

  &::after {
    content: attr(data-tips);
    white-space: nowrap;
    position: absolute;
    top: 100%;
    left: 50%;
    padding: 3px 5px;
    margin-top: 3px;
    color: #fff;
    font-size: 12px;
    background: #5b5b5b;
    border-radius: 3px;
    transform: translateX(-50%);
    display: none;
  }
  &:hover {
    &::after {
      display: block;
    }
  }
  &.hover-show-security-tips {
    &[data-tips]::after {
      display: none;
    }
    &:hover .security-tips {
      display: block;
    }
  }
  .security-tips {
    display: none;
    position: absolute;
    top: 28px;
    left: 0;
    width: 190px;
    &.show-security-tips {
      display: block;
    }
  }
}
</style>

